import React, { useEffect } from 'react';
import WorkOrderGrid from '../../../features/dealer/work-order-grid/components/WorkOrderGrid';
import { useTitle } from "../../../contexts/title";
import OrderTypeSelector from '../../../features/dealer/order-type-selector/components/OrderTypeSelector';

export default function WorkOrdersPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Work Orders')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<OrderTypeSelector />
				<WorkOrderGrid />
			</div>
		</React.Fragment>
	)
} 
